import React, { useEffect, useMemo, useRef, useState } from "react";
import { Editor } from "primereact/editor";
import FeatherIcon from "feather-icons-react";
import { Col, Row } from "reactstrap";
import FloatInput from "src/components/Common/FloatInput";
import * as Yup from "yup";
import { Formik, Form, ErrorMessage, FormikBag, FormikComputedProps, FormikFormProps, FormikHandlers, FormikContextType, FormikRegistration } from "formik";
import ErrorText from "src/components/UI/ErrorText";
import {
  formatChatTime,
  formatDate,
  hasAdminOrEmployeeRoleHandler,
  hasDealerRoleHandler,
  hasManufacturerRoleHandler,
} from "src/helpers/common_helpers";
import { useParams, useLocation } from "react-router";
import { Chips } from "primereact/chips";
import { AutoComplete } from "primereact/autocomplete";
import Button from "src/components/UI/Button";
import { API } from "src/util/api";
import { useDispatch } from "react-redux";
import { getJobsheetView, getPendingReasonCCMailListLoading, getPendingReasonLoading, updateHoldLoading } from "src/store/actions";

import { useSelector } from "react-redux";
import { RootReducerState } from "src/store/reducers";
import { useToast } from 'src/components/Common/ReactToaster';
import ChatLoader from "./ChatLoader";
import FilePreviewList from "./FilePreviewList";
import { getFileIcon } from "./GroupChat";
import noSpam from './no-spam.svg';

interface groupChatProps {
  jobsheet: any;
  id: any;
  selectedAction?: string;
}


const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const GroupChatView = ({ jobsheet, id, selectedAction = "" }: groupChatProps) => {
  console.log("jobsheet?.inPending", jobsheet?.inPending)
  // const { id } = useParams();
  const quillRef: any = useRef<any>(null);
  const { showToast } = useToast();
  const dispatch = useDispatch()
  const [messages, setMessages] = useState<any>([]);
  const [addCCButton, setAddCCButton] = useState<boolean>(false);
  const [chatLoading, setChatLoading] = useState<boolean>(true);
  const [emailInput, setEmailInput] = useState("");
  const [filteredEmails, setFilteredEmails] = useState<string[]>([]);
  const { pendingReasonCCMailList, pendingReason, pendingReasonAll } = useSelector(
    (state: RootReducerState) => state.jobsheetReducer
  );
  const [allSuggestions, setAllSuggestions] = useState<string[]>([]);
  const fileInputRef = useRef<any>(null);
  const [selectedFile, setSelectedFile] = useState<any>([]);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [canAllowPending, setCanAllowPending] = useState<boolean | null>(null);
  const location = useLocation();

  useEffect(() => {
    const fetchCanAllowPending = async () => {
      if (id) {
        try {
          const response = await API.canAllowPendingApi(id);
          setCanAllowPending(response.data);
        } catch (error) {
          console.error("Error fetching canAllowPending", error);
        }
      }
    };
    fetchCanAllowPending();
  }, [id, location]);
  const hasApprove = useMemo(() => {
    return messages?.some((data: any) => data.pendingReason == "Awaiting Supplier Approval / Advice")
  }, [messages])
  console.log(messages)
  useEffect(() => {
    if (pendingReasonCCMailList?.length > 0) {
      setAllSuggestions(pendingReasonCCMailList?.map((data: any) => data.email))
    }
  }, [pendingReasonCCMailList])

  const getChatData = async () => {
    setChatLoading(true)
    try {
      const response = await API.getPendingReasonChatListApi(id)
      if (response.data) {
        setMessages(response.data)
      }
    } catch (error: any) {

    }
    setChatLoading(false)
    debugger
  }
  useEffect(() => {
    if (id) {
      getChatData()
    }
  }, [id])

  useEffect(() => {
    if (jobsheet && hasAdminOrEmployeeRoleHandler()) {
      dispatch(getPendingReasonCCMailListLoading(jobsheet?.jobPrefix))
    }
    if (hasAdminOrEmployeeRoleHandler()) {
      dispatch(getPendingReasonLoading());
    }
  }, [jobsheet])
  // Get current user from localStorage
  const currentUser = JSON.parse(localStorage.getItem("authUser") || "{}");

  // Group messages by date
  const groupedMessages = useMemo(() => {
    return messages?.reduce((groups: any, msg: any) => {
      const dateKey = formatDate(msg.time);
      if (!groups[dateKey]) groups[dateKey] = [];
      groups[dateKey].push(msg);
      return groups;
    }, {});
  }, [messages]);

  const SPECIAL_REASONS = [
    "Awaiting for Necessory information",
    "Awaiting for Necessary information",
    "Awaiting for Confirmation from Dealer",
  ];

  const normalize = (str: string) => str?.replace(/\s+/g, " ").trim().toLowerCase() || "";
  console.log("messages", messages)
  const lastPendingReason = useMemo(() => {
    if (!messages || messages.length === 0) return null;
    const filteredMessages = messages.filter((msg: any) =>
      ["Admin", "Employee", "Auto Update"].includes(msg.userType) && msg.pendingReason
    );
    if (filteredMessages.length === 0) return null;
    return filteredMessages[filteredMessages.length - 1];
  }, [messages]);

  const isSpecialPending = useMemo(() => {
    const currentReason = normalize(lastPendingReason?.pendingReason || "");
    return (
      jobsheet?.inPending &&
      lastPendingReason &&
      SPECIAL_REASONS.some((r) => normalize(r) === currentReason) && hasAdminOrEmployeeRoleHandler()
    );
  }, [jobsheet?.inPending, lastPendingReason]);

  const isAdmin = hasAdminOrEmployeeRoleHandler();
  const isDealer = hasDealerRoleHandler()
  const isManufacturer = hasManufacturerRoleHandler();

  const DEALER_SPECIAL_REASONS = [
    "Awaiting for Confirmation from Dealer",
    "Awaiting for Necessory information",
    "Awaiting for Necessary information"
  ];

  const MANUFACTURER_SPECIAL_REASONS = [
    "Awaiting Supplier Approval / Advice",
    "Awaiting for updated Software release"
  ];

  const canDealerReply = useMemo(() => {
    if (!lastPendingReason || !jobsheet?.inPending) return false;
    const currentReason = normalize(lastPendingReason.pendingReason);
    return isDealer && DEALER_SPECIAL_REASONS.some(r => normalize(r) === currentReason);
  }, [isDealer, lastPendingReason, jobsheet?.inPending]);

  const canManufacturerReply = useMemo(() => {
    if (!lastPendingReason || !jobsheet?.inPending) return false;
    const currentReason = normalize(lastPendingReason.pendingReason);
    return isManufacturer && MANUFACTURER_SPECIAL_REASONS.some(r => normalize(r) === currentReason);
  }, [isManufacturer, lastPendingReason, jobsheet?.inPending]);

  const pendingreasonDropdown = useMemo(() => {
    let reasons = pendingReason || [];
    if (canAllowPending === false) {
      reasons = reasons.filter((reason: any) => reason.name === "Confirmation received from Dealer");
    }
    if (jobsheet?.type === "TV") {
      reasons = reasons.filter((reason: any) => {
        const normalizedName = normalize(reason.name);
        const isDealerReason = DEALER_SPECIAL_REASONS.some(r => normalize(r) === normalizedName);
        const isSupplierReason = MANUFACTURER_SPECIAL_REASONS.some(r => normalize(r) === normalizedName);
        return !isDealerReason && !isSupplierReason;
      });
    }
    return reasons?.length > 0
      ? reasons
        .map((reason: any) => {
          let data: any = {};
          data["value"] = reason.id;
          data["label"] = reason.name;
          return data;
        })
        .sort((a: any, b: any) => {
          const labelA = a.label.toUpperCase().trim();
          const labelB = b.label.toUpperCase().trim();
          if (labelA < labelB) {
            return -1;
          }
          if (labelA > labelB) {
            return 1;
          }
          return 0;
        })
      : [];
  }, [pendingReason, canAllowPending, jobsheet])

  const lastPendingReasonId = useMemo(() => {
    if (!lastPendingReason?.pendingReason) return null;
    const normalizedLastReason = normalize(lastPendingReason.pendingReason);

    // 1. Try finding it by ID on the last message
    if (lastPendingReason.pendingReasonId) {
      return lastPendingReason.pendingReasonId;
    }

    // 2. Try finding it in the active dropdown options
    const foundInDropdown = pendingreasonDropdown?.find(
      (val: any) => normalize(val.label) === normalizedLastReason
    )?.value;
    if (foundInDropdown) return foundInDropdown;

    // 3. Fallback to all loaded pending reasons (if active list is filtered/cleared)
    const foundInAll = pendingReasonAll?.find(
      (val: any) => normalize(val.name) === normalizedLastReason
    )?.id;

    return foundInAll || null;
  }, [lastPendingReason, pendingreasonDropdown, pendingReasonAll]);

  // Dynamically append the current pending reason to the options so the dropdown component can bind it
  const dropdownOptions = useMemo(() => {
    const isDisabled = jobsheet?.inPending || isSubmitted;
    if (!isDisabled) {
      return pendingreasonDropdown;
    }

    if (!lastPendingReason?.pendingReason) return pendingreasonDropdown;
    const normalizedLastReason = normalize(lastPendingReason.pendingReason);
    const exists = pendingreasonDropdown?.some(
      (val: any) => normalize(val.label) === normalizedLastReason
    );
    if (exists) return pendingreasonDropdown;

    const newOption = {
      value: lastPendingReasonId || "",
      label: lastPendingReason.pendingReason,
    };
    return [...(pendingreasonDropdown || []), newOption];
  }, [pendingreasonDropdown, lastPendingReason, lastPendingReasonId, jobsheet?.inPending, isSpecialPending, isSubmitted]);


  const renderMessage = (msg: any) => {
    let pendingReasonUsers = ["Admin", "Employee", "Auto Update"]
    const direction = msg.currentUserId === currentUser.uid ? "right" : "left";

    return (
      <div key={msg.time} className={`message-${direction}`}>
        <div className={`message-card ${direction} ${msg.pendingReason ? "pr" : ''}`}>
          {msg.pendingReason && pendingReasonUsers.includes(msg.userType) && (
            <div className="chat-card-header">{msg.pendingReason}</div>
          )}

          {msg.chat && <div className="chat-card-body" dangerouslySetInnerHTML={{ __html: msg.chat }}>

            {/* {msg.chat} */}
          </div>}
          {msg?.chatDocumentDto?.length ? (
            <div className="file-show-list">
              {msg?.chatDocumentDto?.map((chatDocument: any, index: any) => {
                return (
                  <div className="file-content" key={index} onClick={() => onFileClick(chatDocument?.documentId)}>
                    <div className="icon">
                      {getFileIcon(chatDocument?.mimeType)}
                    </div>
                    {chatDocument?.documentName}
                  </div>
                )
              })}

            </div>
          ) : null}
        </div>
        <div className="message-meta">
          <span className="author-name">{msg.name}</span>
          <span className="time">{formatChatTime(msg.time)}</span>
        </div>
      </div>
    );
  };

  const onFileClick = async (fileId: any) => {
    let { data } = await API.getProofDoucumentLinkApi(fileId)
    debugger
    if (data) {
      openDocumet(data)
    }
  }
  const openDocumet = (link: any) => {
    if (link != "" && link != undefined && link != null) {
      const newWindow = window.open(link);
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        alert('Popup blocked! Please allow popups for this site to view the document.');
      } else {
        newWindow.focus();
      }
    }
  }
  const initialValues: any = useMemo(() => {
    return {
      message: "",
      pendingReason: isSpecialPending ? lastPendingReasonId : "",
      pendingReasonId: isSpecialPending ? lastPendingReasonId : 0,
      ccMails: [] as string[],
    };
  }, [isSpecialPending, lastPendingReasonId]);



  const validationSchema = Yup.object().shape({
    pendingReason: hasAdminOrEmployeeRoleHandler() ? Yup.string().required("Pending reason is required") : Yup.string(),
    message: Yup.string()
      .test("is-non-empty", "Message Content is required", (value) => {
        if (!value) return false;
        const textContent = value.replace(/<[^>]*>/g, "").trim();
        return textContent.length > 0;
      })
      .required("Message Content is required"),
  });

  const convertFileIntoPayload = (fileArray: any) => {
    let data = fileArray?.map((data: any) => {
      return {
        "id": 0,
        "jobId": Number(id),
        "proofName": data?.name,
        "userId": JSON.parse(localStorage.getItem("authUser") || "")?.uid,
        "file": "",
        "fileContentType": data.type,
        "fileName": data.name,
        "isDealerUpdate": false,
        "documentDetail": {
          "fileSize": data.size,
          "mimeType": data.type,
          "name": data?.name
        }
      }
    })
    return data
  }

  const handleSubmit = (values: any, reset: any, string: string, setFieldError: any) => {
    debugger
    setChatLoading(true)
    if (string === "hold") {
    }

    const newMessage = {
      jobId: id,
      pendingComments: values.message,
      pendingReason: pendingreasonDropdown?.find((val: any) => val.value == values.pendingReason)?.label || "",
      pendingReasonId: isSpecialPending ? null : (values.pendingReason || null),
      inPending: (hasAdminOrEmployeeRoleHandler() ? true : false),
      commentAt: new Date().toISOString(),
      chatCcMail: values.ccMails?.length > 0 ? values.ccMails?.map((data: any) => ({ cc: data })) : [],
      isApproved: string == "approve" ? true : false,
      isReject: string == "reject" ? true : false,
      isHold: string == "hold" ? true : false,
      isReplay: (isManufacturer && string == "") ? true : false,
      isUploadFile: selectedFile?.length > 0 ? true : false,
      isMountReplay: isSpecialPending,
      createOrUpdateAJobProofDocumentDtoList: selectedFile?.length > 0 ? convertFileIntoPayload(selectedFile) : []
    };


    setFieldError("pendingReason", "");
    setFieldError("message", "");
    handleApiSubmit(newMessage)
    // resetForm();
    reset()
  };

  const handleApiSubmit = async (formattedData: any) => {
    debugger
    try {
      const response: any = await API.sendNewPendingReasonChatApi(formattedData)
      if (response?.data?.length > 0) {
        for (let i = 0; i < response?.data?.length; i++) {
          let fileData = response?.data[i]
          if (fileData?.fileUploadUrl) {
            const fileResponse = await uploadFile(fileData, selectedFile[i]);
          }
        }
      }
      if (response) {
        if (formattedData.isHold && hasAdminOrEmployeeRoleHandler()) {
          await API.supplierHoldApi({ replayComments: formattedData.pendingComments }, id);
        }

        getChatData()
        dispatch(getJobsheetView(id))
        if (formattedData.pendingReasonId) {
          showToast(`Pending send successfully`, { type: "success" });
          setIsSubmitted(true);
        }
      }

      setTimeout(() => {
        try {
          const resp = API.sendNewPendingReasonMosChatApi(formattedData)
        } catch (error: any) { }
      }, 1000)
    } catch (error: any) {

    } finally {
      setSelectedFile([])
      setChatLoading(false)
      setIsSubmitted(false)
    }
  }

  const uploadFile = async (fileData: any, selectedFile: any) => {
    try {
      const fileUploadResponse = await fetch(fileData.fileUploadUrl, {
        method: "PUT",
        headers: {
          "Content-Type": selectedFile.type,
        },
        body: selectedFile,
      });
      if (fileUploadResponse?.ok) {
        const successResponse = await API.chatFileUploadSuccessApi(fileData?.proofId)
      }
      if (!fileUploadResponse.ok) {
        throw new Error(`Upload failed with status ${fileUploadResponse.status}`);
      }

      return fileUploadResponse; // or await fileUploadResponse.json() if it returns JSON
    } catch (error) {
      console.error("File upload error:", error);
      throw error;
    }
  };


  const bottomRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [groupedMessages]);



  const handleFileChange = (e: any) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setSelectedFile((prev: any) => [...prev, ...files]);
      console.log("Selected files:", files);
    }
  };

  return (
    <React.Fragment>

      <Formik
        onSubmit={(e: any) => {
          e.stopPropagation(); // prevent bubbling to outer form
          e.preventDefault();
          debugger // stop browser reload
          // handleSubmit();
        }}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({ values, setFieldValue, handleChange, errors, handleBlur, validateForm, resetForm, setFieldTouched, setFieldError, touched }: any) => {

          const searchEmail = (event: any) => {
            const query = event.query.trim().toLowerCase();
            if (!query) {
              // Show only emails not already selected
              const availableEmails = allSuggestions.filter(
                (email) => !values.ccMails.includes(email)
              );
              setFilteredEmails(availableEmails);
              return;
            }

            // Filter and exclude already selected ones
            const filtered = allSuggestions.filter(
              (email) =>
                email.toLowerCase().includes(query) &&
                !values.ccMails.includes(email)
            );
            setFilteredEmails(filtered);
          };
          return (
            <Form>
              {/* Pending Reason Dropdown */}
              <Row>
                <Col xl={6} lg={6} md={7} sm={12} className="mt-mb">
                  {(isAdmin && jobsheet?.inPending) && <FloatInput
                    type="dropdown"
                    name="pendingReason"
                    label="Pending reason"
                    onChange={handleChange}
                    value={values.pendingReason}
                    options={dropdownOptions}
                    placeholder="Select Pending Reason"
                    required
                    className="w-100"
                    disabled={jobsheet?.inPending || isSubmitted}
                    onBlur={handleBlur}
                    invalid={errors.pendingReason && touched?.pendingReason ? true : false}
                  />}
                </Col>
              </Row>
              {/* Chat Section */}
              <div className={`main-area ${(!jobsheet?.inPending && isAdmin) ? "chat-only" : (isDealer || isManufacturer) ? "dealer-chat" : ""}`}>
                <div className="conversation-container">
                  {chatLoading &&
                    <ChatLoader />
                  }
                  {(Object.entries(groupedMessages)?.length == 0 && !chatLoading) && <NoMessagesView />}
                  {Object.entries(groupedMessages).map(([date, msgs]: any) => (
                    <div key={date}>
                      <div className="date-section">
                        <div className="date-header">{date}</div>
                      </div>
                      {msgs.map(renderMessage)}
                    </div>
                  ))}
                  <div ref={bottomRef} />
                </div>
              </div>
              {/* Email Section */}
              <div className="chat-form-area">
                <FilePreviewList files={selectedFile} setSelectedFile={setSelectedFile} isLoading={chatLoading} />
                {/* Message Editor */}
                {((jobsheet?.inPending && isAdmin) || canDealerReply || canManufacturerReply || (isManufacturer && hasApprove && jobsheet?.isApprovedPending)) &&
                  <Col lg={12} className="mt-2 chat-box  d-flex gap-3">
                    {/* <label htmlFor="message">
                  Message<span className="text-danger ml-05">*</span>
                </label> */}
                    <div className="file-textarea">
                      <textarea
                        placeholder="Type a message..."
                        className="chat-text-area"
                        value={values.message}
                        name={"message"}
                        onChange={handleChange}
                      />
                      <div className="" style={{ position: "absolute", bottom: "-12px" }}><ErrorMessage name={"message"} component={ErrorText} /></div>
                      <span className="file-upload-button">
                        <button
                          type="button"
                          onClick={() => fileInputRef.current.click()}
                          className="ql-custom-upload"
                          style={{ border: "none", background: "transparent", cursor: "pointer" }}
                        >
                          <FeatherIcon icon="paperclip" />
                        </button>
                      </span>
                    </div>
                    {((((!jobsheet?.inPending || isSpecialPending) && isAdmin) || canDealerReply || canManufacturerReply || (isManufacturer && hasApprove && jobsheet?.isApprovedPending))) &&
                      <div className="text-end mt-2 d-flex align-items-center" style={{ height: "50px" }}>
                        <div>
                          <input
                            type="file"
                            ref={fileInputRef}
                            multiple
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                          />
                        </div>

                        {
                          (isManufacturer && hasApprove && jobsheet?.isApprovedPending)
                          &&
                          <>
                            {(selectedAction === "" || selectedAction === "Approved") && (
                              <Button
                                className="btn-success me-2"
                                label="Approve"
                                type="button"
                                onClick={async () => {
                                  setFieldTouched('pendingReason', true)
                                  setFieldTouched('message', true)
                                  const formErrors = await validateForm();
                                  if (Object.keys(formErrors).length === 0) {
                                    handleSubmit(values, resetForm, "approve", setFieldError);
                                  } else {

                                  }
                                }}
                              />
                            )}
                            {(selectedAction === "" || selectedAction === "Rejected") && (
                              <Button
                                className="btn-danger me-2"
                                label="Reject"
                                type="button"
                                onClick={async () => {
                                  // ✅ Manually trigger validation first
                                  setFieldTouched('pendingReason', true)
                                  setFieldTouched('message', true)
                                  const formErrors = await validateForm();
                                  if (Object.keys(formErrors).length === 0) {
                                    // ✅ No errors, submit safely
                                    handleSubmit(values, resetForm, "reject", setFieldError);
                                  } else {
                                    // ❌ There are validation errors

                                  }
                                }}
                              />
                            )}
                            {(selectedAction === "" || selectedAction === "Hold") && (
                              <Button
                                className="btn-warning me-2"
                                label="Hold"
                                type="button"
                                onClick={async () => {
                                  setFieldTouched('pendingReason', true)
                                  setFieldTouched('message', true)
                                  const formErrors = await validateForm();
                                  if (Object.keys(formErrors).length === 0) {
                                    handleSubmit(values, resetForm, "hold", setFieldError);
                                  }
                                }}
                              />
                            )}

                          </>

                        }
                        {(selectedAction === "" || selectedAction === "Reply") && (isAdmin || canDealerReply || canManufacturerReply) && (
                          <button className={`btn ${isManufacturer ? "send-button-manufacturer" : 'send-button'}`} type="button" onClick={async () => {
                            // ✅ Manually trigger validation first
                            setFieldTouched('pendingReason', true)
                            setFieldTouched('message', true)
                            const formErrors = await validateForm();
                            if (Object.keys(formErrors).length === 0) {
                              if (isDealer || isManufacturer) {
                                setChatLoading(true);
                                try {
                                  const jobRes = await API.getJobByIdAPI(id);
                                  const job = jobRes.data;
                                  let canStillReply = false;

                                  if (job?.inPending) {
                                    const chatRes = await API.getPendingReasonChatListApi(id);
                                    const latestMessages = chatRes.data;
                                    const filtered = latestMessages?.filter((msg: any) =>
                                      ["Admin", "Employee", "Auto Update"].includes(msg.userType) && msg.pendingReason
                                    );
                                    const newLastPendingReason = filtered?.length > 0 ? filtered[filtered.length - 1] : null;

                                    if (newLastPendingReason) {
                                      const currentReason = normalize(newLastPendingReason.pendingReason);
                                      if (isDealer && DEALER_SPECIAL_REASONS.some(r => normalize(r) === currentReason)) {
                                        canStillReply = true;
                                      } else if (isManufacturer && MANUFACTURER_SPECIAL_REASONS.some(r => normalize(r) === currentReason)) {
                                        canStillReply = true;
                                      }
                                    }
                                  }

                                  if (!canStillReply) {
                                    showToast("Job status has changed. You can no longer reply.", { type: "error" });
                                    dispatch(getJobsheetView(id));
                                    getChatData();
                                    setChatLoading(false);
                                    return;
                                  }
                                } catch (error) {
                                  console.error("Error verifying job status", error);
                                }
                                setChatLoading(false);
                              }
                              // ✅ No errors, submit safely
                              handleSubmit(values, resetForm, "", setFieldError);
                            } else {
                              // ❌ There are validation errors

                            }
                          }}>
                            <FeatherIcon icon="send" className="me-1" /> {isManufacturer ? "Reply" : ""}
                          </button>
                        )}
                      </div>
                    }
                  </Col>

                }
                {(isAdmin && jobsheet?.inPending) &&
                  <div className="email-section">
                    {addCCButton &&
                      <AutoComplete
                        multiple
                        value={values.ccMails}
                        suggestions={filteredEmails}
                        completeMethod={searchEmail}
                        onChange={(e) => {
                          // Validate last typed email
                          const last = e.value[e.value.length - 1];
                          if (last && !emailRegex.test(last)) {
                            e.value.pop();
                            return;
                          }
                          setFieldValue("ccMails", e.value);
                        }}
                        placeholder="Search and select CC emails..."
                        dropdown
                        className="w-100"
                        emptyMessage="No cc email is available"
                        showEmptyMessage={true}
                      />}
                    <button className="add-cc-btn" type="button" onClick={() => { setAddCCButton(prev => !prev); setFieldValue('ccMails', []) }}>
                      <FeatherIcon icon="mail" />{addCCButton ? "Remove CC Mails" : " Add More CC Mails"}
                    </button>
                  </div>
                }
              </div>
            </Form>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default GroupChatView;


const NoMessagesView = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", height: "100%", justifyContent: "center" }}>
      <img src={noSpam} style={{ width: "100px" }} />
      <div>No Messages Yet</div>
    </div>
  )
}